import { Component, Input, OnInit } from '@angular/core';
import {NgIf, NgStyle, CurrencyPipe, DatePipe} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {DurationPipe} from '../shared/pipes/duration.pipe';
import { Course } from '../models/course.model';
import {User} from '../models/user.model';
import {TenantInfo} from '../models/tenant.model';

@Component({
  selector: 'certificate-preview',
  templateUrl: './certificate-preview.component.html',
  styleUrls: ['./certificate-preview.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgStyle,
    CurrencyPipe,
    DatePipe,
    DurationPipe,
    TranslateModule,
  ]
})

export class CertificatePreviewComponent implements OnInit {

  @Input()
  course: Course;

  @Input()
  user: User;

  @Input()
  tenant: TenantInfo;

  @Input()
  certificateIssuedDate: any;

  @Input()
  authorsName: [];

  @Input()
  backgroundImageUrl: string;

  @Input()
  base64Image: any;

  @Input()
  nameUnavailable: string;

  constructor() {}

  ngOnInit() {

  }
}
